//  Create a class that will store current project id in local storage and will retrieve it when needed base on the product id
class CurrentCustomStore {
  projectsByProductID = [];

  constructor() {}

  getProjects(){
    return this.projectsByProductID;
  }
  
  getLocalStoreKey(productID) {
    return `currentProject-${productID}`;
  }

  removeLocalStorage(productID){
    localStorage.removeItem(`currentProject-${productID}`);
  }

  removeProjects(){
    this.projectsByProductId = [];
  }
  
  getProjectByProduct(productID) {
    if (this.projectsByProductID[productID]) {
      return this.projectsByProductID[productID];
    }

    // Retrieve the project id from local storage if not present in the cache
    const key = this.getLocalStoreKey(productID);
    const projectStr = localStorage.getItem(key);
    if (projectStr) {
      const project = JSON.parse(projectStr);
      this.projectsByProductID[productID] = project;
      return project;
    }

    return null;
  }

  setProjectByProduct(productID, project) {
    const key = this.getLocalStoreKey(productID);

    // save project to local storage
    const projectStr = JSON.stringify(project);
    localStorage.setItem(key, projectStr);
    this.projectsByProductID[productID] = project;
  }

  getProjectURL(productID) {
    const project = this.getProjectByProduct(productID);
    if (project) {
      return   `${project.url}${project.id}`;
    }
    return "";
  }
}

//   Create a singleton instance of the class to be used in the application
window.currentCustomStore = new CurrentCustomStore();
